import VerifiedProfileActions from 'actions/VerifiedProfileActions';
import { AA, Method, Resource } from 'sdk';

class VerifiedProfileActionCreator {
  fetchProfileProperties(params) {
    AA.api(Resource.miniCustomerProfile, Method.get, params).then((response) => {
      VerifiedProfileActions.fetchVerifiedProfileSucceeded(response.data);
    }, (error) => {
      VerifiedProfileActions.fetchVerifiedProfileFailed({ requestParams: params, error });
    });
  }

  fetchClaimedEntity(params) {
    AA.api(Resource.verifiedProfileEntities, Method.get, params).then((response) => {
      VerifiedProfileActions.fetchClaimedEntitySucceeded(response.data);
    }, (error) => {
      VerifiedProfileActions.fetchClaimedEntityFailed({ requestParams: params, error });
    });
  }

  fetchAuthorIdentity(amazonAuthorId) {
    AA.api(Resource.author(amazonAuthorId), Method.get).then((response) => {
      VerifiedProfileActions.fetchAuthorIdentitySucceeded(response.data);
    }, (error) => {
      VerifiedProfileActions.fetchAuthorIdentityFailed({ requestParams: amazonAuthorId, error });
    });
  }

  fetchAccountPool() {
    AA.api(Resource.accountPool, Method.get).then((response) => {
      VerifiedProfileActions.fetchAccountPoolSucceeded(response.data);
    }, (error) => {
      VerifiedProfileActions.fetchAccountPoolFailed({ error });
    });
  }
}

export default new VerifiedProfileActionCreator();
